import React, { useCallback, useEffect } from 'react'
import ModalButton from '../../../../../../Elements/modal/ButtonsModal/ModalButton'
import { useTranslation } from 'react-i18next'
import { OrderButtonWrap } from './index.styled'
import { useDispatch, useSelector } from 'react-redux'
import { setRestaurantPaymentTypeModal, setRestaurantShowInterimOrderModal } from '../../../../../../../redux/action/restaurant'
import { fetchTableOrdersThunk } from '../../../../../../../redux/thunk/restaurant/order'

const RestaurantOrderButton = React.memo(() => {
	const { t } = useTranslation()
	const table = useSelector(state => state.restaurant.table)
	const button = { icon: 'show', text: t('order.modal.show_order'), show: true }
	const dispatch = useDispatch()

	useEffect(() => {
		if (table?.id) {
			dispatch(fetchTableOrdersThunk(table?.id, true, 'BEING_PREPARED,PREPARED,PLACED'))
		}
	}, [table?.id]) // eslint-disable-line react-hooks/exhaustive-deps

	const handleOpenModal = useCallback(() => {
		dispatch(setRestaurantPaymentTypeModal(false))
		dispatch(setRestaurantShowInterimOrderModal(true))
	}, [dispatch])

	return (
		<OrderButtonWrap>
			<ModalButton button={button}
									 onClick={handleOpenModal}
									 isActive={false} />
		</OrderButtonWrap>
	)

})

RestaurantOrderButton.displayName = 'RestaurantOrderButton'
export default RestaurantOrderButton
